import { Pipe, PipeTransform } from '@angular/core';
import * as numeral from 'numeral';
import { Utility } from '../core/helpers/utility';

@Pipe({
    name: 'mcNumber'
})

export class McNumberPipe implements PipeTransform {
    transform(value: string, nanValue: string, customFormat: string, scientific: string = '', toPercentage: boolean = false): any {
        let numValue = parseFloat(value);

        if (isNaN(numValue) || !isFinite(numValue)) {
            return nanValue;
        }

        let result = value;

        if (toPercentage) {
            numValue = value = Utility.getPercentageFromFraction(value);
        }

        // If custom format provided, use it for numeric formatting.
        if (customFormat) {
            return numeral(value).format(customFormat);
        }

        // No custom format provided; use default formatting logic.
        const absValue = Math.abs(numValue);
        if (absValue >= 100) { // xxx
            result = numeral(value).format('0,0');

        } else if (absValue >= 10) { // xx.x
            result = numeral(value).format('0,0.0');

        } else if (absValue >= 1) { // x.xx
            result = numeral(value).format('0,0.00');

        } else if (absValue >= 0.001) { // 0.xxx
            result = numeral(value).format('0,0.000');

        } else if (absValue < 0.001 && absValue > 0) { // x.xx e-yy
            if (scientific) {
                result = numeral(value).format('0.00e+0');
                return result;
            }
            result = '<0.001';
        }
        return result;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/mc-number.pipe.ts